import awsExports from '../aws-exports';

awsExports.aws_user_files_s3_bucket
export const BUCKET_URL = "https://" + awsExports.aws_user_files_s3_bucket + ".s3.eu-central-1.amazonaws.com/public/";
